module.exports = __webpack_public_path__ + "img/icon-fb.d93f8d88.svg";